import React, { Component, PropTypes } from 'react';
import * as ReactDOM from 'react-dom';
import ConfigurationCheckbox from '../../widgets/ConfigurationCheckbox';
import ReactSparkSelectInput from '../../widgets/ReactSparkSelectInput';
import PricingDisplaySection from '../sections/PricingDisplaySection';
import {
    addOnsCrossSellConfigItems,
    thirdPartyOffersConfigItems,
    travelAgencyDisplayNameOptions
} from '../../../constants/GeneralConfiguration';
import { getText } from '../../../../lib/utils';
import { getShowAddOnsMigratedConfig } from '../../../utils/configuration-utils';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import ReactSparkCheckbox from '../../widgets/ReactSparkCheckbox';
import ReactSparkToggle from '../../widgets/ReactSparkToggle';
import ThirdPartyOffersSection from '../sections/ThirdPartyOffersSection';

class GeneralConfiguration extends Component {
    sections = [];

    componentDidMount() {
        if (this.props.onIndex) {
            this.sections.forEach((section, key) => {
                this.props.onIndex(getText(ReactDOM.findDOMNode(section)), [key]);
            });
        }
    }

    registerSection(key) {
        return node => (this.sections[key] = node);
    }

    sectionStyleHandler(key) {
        return this.props.searchIndex !== undefined && this.props.searchIndex.indexOf(key) === -1
            ? { display: 'none' }
            : {};
    }

    setTravelAgencyDisplayName = value => {
        this.props.setConfigText('travelAgencyDisplayName', null, value);
    };

    onAddOnConfigChange = (code, onChangeValue) => {
        const showAddOnsMigratedConfig = getShowAddOnsMigratedConfig(this.props.currentConfigCopy);
        if (!isEmpty(showAddOnsMigratedConfig)) {
            Object.keys(showAddOnsMigratedConfig).forEach(key => {
                this.props.setConfigBoolean(key, showAddOnsMigratedConfig[key]);
            });
            this.props.unsetConfigValue('showAddOnsDisplayType');
        }
        this.props.toggleConfigBoolean(code, onChangeValue);
    };

    onThirdPartyOfferToggle = (code, currentValue) => {
        this.props.toggleConfigBoolean(code, currentValue);
    };

    render() {
        const showAddOnsMigratedConfig = getShowAddOnsMigratedConfig(this.props.currentConfigCopy);
        const showAddOns = has(showAddOnsMigratedConfig, 'showAddOns')
            ? showAddOnsMigratedConfig.showAddOns
            : this.props.currentConfigCopy.showAddOns;
        return (
            <div className="spark-panel__content col-lg-12">
                <section className="row spark-panel__content">
                    <div className="col-sm-12">
                        <h3>General Settings</h3>
                        <div ref={this.registerSection(17)} style={this.sectionStyleHandler(17)}>
                            <h4>BOOKING FLOW</h4>
                            <ConfigurationCheckbox
                                ref={this.registerSection(1)}
                                style={this.sectionStyleHandler(1)}
                                isDisabled={this.props.isDisabled}
                                title="Show Addons/Shop page after Rooms"
                                code="showAddOns"
                                onChange={this.onAddOnConfigChange}
                                value={showAddOns}
                            />
                            <ConfigurationCheckbox
                                ref={this.registerSection(2)}
                                style={this.sectionStyleHandler(2)}
                                isDisabled={this.props.isDisabled}
                                title="Require users to View Cart before Checkout"
                                code="viewCartBeforeCheckout"
                                onChange={this.props.toggleConfigBoolean}
                                value={this.props.currentConfigCopy.viewCartBeforeCheckout}
                            />
                        </div>
                    </div>
                </section>
                <section className="row spark-panel__content">
                    <div className="col-sm-12" ref={this.registerSection(11)} style={this.sectionStyleHandler(11)}>
                        <h4>GENERAL</h4>
                        <ConfigurationCheckbox
                            ref={this.registerSection(3)}
                            style={this.sectionStyleHandler(3)}
                            isDisabled={this.props.isDisabled}
                            title="Price Summary Expanded"
                            code="priceSummaryExpanded"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.priceSummaryExpanded}
                        />
                        <ConfigurationCheckbox
                            ref={this.registerSection(4)}
                            style={this.sectionStyleHandler(4)}
                            isDisabled={this.props.isDisabled}
                            title="Display Deposit Amount"
                            code="displayProductDepositAmount"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.displayProductDepositAmount}
                        />
                        <ConfigurationCheckbox
                            ref={this.registerSection(5)}
                            style={this.sectionStyleHandler(5)}
                            isDisabled={this.props.isDisabled}
                            title="Display Cancel Amount"
                            code="displayProductCancelAmount"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.displayProductCancelAmount}
                        />
                        <ConfigurationCheckbox
                            ref={this.registerSection(6)}
                            style={this.sectionStyleHandler(6)}
                            isDisabled={this.props.isDisabled}
                            title="Display Children Policy"
                            code="displayChildrenPolicy"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.displayChildrenPolicy}
                        />
                        <ConfigurationCheckbox
                            ref={this.registerSection(7)}
                            style={this.sectionStyleHandler(7)}
                            isDisabled={this.props.isDisabled}
                            title="Display Additional Policy"
                            code="displayAdditionalPolicy"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.displayAdditionalPolicy}
                        />
                        <ConfigurationCheckbox
                            ref={this.registerSection(8)}
                            style={this.sectionStyleHandler(8)}
                            isDisabled={this.props.isDisabled}
                            title="Do not decrement room inventory until reservation confirmation"
                            code="isStoredStatusEnabled"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.isStoredStatusEnabled}
                        />
                        <ReactSparkSelectInput
                            isDisabled={this.props.isDisabled}
                            label="Travel Agency Display Name"
                            defaultValue={this.props.currentConfigCopy.travelAgencyDisplayName}
                            values={travelAgencyDisplayNameOptions}
                            onChange={event => this.setTravelAgencyDisplayName(event.target.value)}
                        />
                    </div>
                </section>
                <div
                    className="row spark-panel__content"
                    ref={this.registerSection(12)}
                    style={this.sectionStyleHandler(12)}
                >
                    <h5 className="col-sm-12">HERO IMAGE</h5>
                    <div className="col-sm-12">
                        <ConfigurationCheckbox
                            isDisabled={this.props.isDisabled}
                            title="Rooms page"
                            code="showHeroImage.productSelection"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.showHeroImage.productSelection}
                            ref={this.registerSection(14)}
                            style={this.sectionStyleHandler(14)}
                        />
                    </div>
                    <div className="col-sm-12">
                        <ConfigurationCheckbox
                            isDisabled={this.props.isDisabled}
                            title="Hotels page"
                            code="showHeroImage.hotelSelection"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.showHeroImage.hotelSelection}
                            ref={this.registerSection(15)}
                            style={this.sectionStyleHandler(15)}
                        />
                    </div>
                    <div className="col-sm-12">
                        <ConfigurationCheckbox
                            isDisabled={this.props.isDisabled}
                            title="Search results page"
                            code="showHeroImage.searchResults"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.showHeroImage.searchResults}
                            ref={this.registerSection(22)}
                            style={this.sectionStyleHandler(22)}
                        />
                    </div>
                </div>
                <section className="row spark-panel__content">
                    <PricingDisplaySection
                        toggleConfigBoolean={this.props.toggleConfigBoolean}
                        isDisabled={this.props.isDisabled}
                        currentConfigCopy={this.props.currentConfigCopy}
                        setConfigText={this.props.setConfigText}
                    />
                </section>
                <section className="row spark-panel__content">
                    <div className="col-sm-12" ref={this.registerSection(11)} style={this.sectionStyleHandler(11)}>
                        <h4>CROSS-SELL CAROUSEL</h4>
                        <p>Select the pages where you want the cross-sell carousel to appear.</p>
                        {addOnsCrossSellConfigItems.map(({ code, title }, index) => (
                            <ConfigurationCheckbox
                                key={code}
                                ref={this.registerSection(23 + index)}
                                style={this.sectionStyleHandler(23 + index)}
                                isDisabled={this.props.isDisabled}
                                title={title}
                                code={code}
                                onChange={this.onAddOnConfigChange}
                                value={
                                    has(showAddOnsMigratedConfig, code)
                                        ? showAddOnsMigratedConfig[code]
                                        : this.props.currentConfigCopy[code]
                                }
                            />
                        ))}
                    </div>
                </section>
                <section className="row spark-panel__content">
                    <div className="col-sm-12">
                        <ThirdPartyOffersSection
                            currentConfigCopy={this.props.currentConfigCopy}
                            isDisabled={this.props.isDisabled}
                            onToggle={this.onThirdPartyOfferToggle}
                            registerSection={this.registerSection.bind(this)}
                            sectionStyleHandler={this.sectionStyleHandler.bind(this)}
                        />
                    </div>
                </section>
            </div>
        );
    }
}

GeneralConfiguration.propTypes = {
    children: PropTypes.element
};

export default GeneralConfiguration;



// WEBPACK FOOTER //
// ./src/components/pages/pages/GeneralConfiguration.js